import StreamWidget from './StreamWidget.vue';

export default StreamWidget;
